/* eslint-disable camelcase */

import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { URL_CHATBOT } from '../constants/endpoints';
import { getToken } from './token.services';

let currentToken: string | null = null;

const chatbotService: AxiosInstance = axios.create({
    baseURL: URL_CHATBOT,
    headers: {
        'Content-Type': 'application/json',
        Apikey: process.env.API_KEY_INTEGRATION,
    },
});

const getAuthToken = async (): Promise<string | null> => {
    if (currentToken) {
        return currentToken;
    }

    currentToken = await getToken();
    return currentToken;
};

chatbotService.interceptors.request.use(
    async (config: any) => {
        const token = await getAuthToken();
        config.headers.Authorization = token;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const retryRequest = async <T>(
    requestFn: () => Promise<AxiosResponse<T>>,
    retries: number = 3,
    delay: number = 500
) => {
    let attempts = 0;

    while (attempts < retries) {
        try {
            return (await requestFn()).data;
        } catch (error: any) {
            if (error.response && error.response.status === 403) {
                currentToken = null;
                attempts++;

                if (attempts < retries) {
                    await new Promise((resolve) => setTimeout(resolve, delay));
                } else {
                    console.error('Todos los intentos fallaron.');
                    throw error;
                }
            } else {
                throw error;
            }
        }
    }
};

export const createSession = async (user_id: string, session_name: string) => {
    const requestFn = async () => {
        return await chatbotService.post('/sessions/create_session', {
            user_id,
            session_name,
        });
    };

    return await retryRequest(requestFn);
};

export const sendMessage = async (
    user_id: string,
    query: string,
    session_id: string
) => {
    const requestFn = async () => {
        return await chatbotService.post('/chat/message', {
            user_id,
            query,
            session_id,
        });
    };

    return await retryRequest(requestFn);
};

export const voteMessage = async (
    session_id: string,
    message_id: string,
    rate: number
) => {
    const requestFn = async () => {
        return await chatbotService.post('/chat/vote', {
            session_id,
            message_id,
            rate,
        });
    };

    return await retryRequest(requestFn);
};
